import { useEffect, useState } from "react";
import { IVehicleVisualRecord } from "../../../../../../types/vehicle-visual-record.type";
import { FormikProvider, useFormik } from "formik";
import { DetailsImageVehicleRow } from "../../fields-upload/DetailsImageVehicleRow";
import ModalAddPhotos from "../../vehicle-delivered/ModalAddPhotos/ModalAddPhotos";
import { updateVehicleVisualRecordField } from "@/common/services/vehicles.api";
import { FaCheck, FaPencilAlt } from "react-icons/fa";

type ReturnedDetailsProps = {
  data: IVehicleVisualRecord;
  onClose?: () => void;
};
export default function ReturnedDetails(props: ReturnedDetailsProps) {
  const [vehicleId, setvehicleId] = useState<string | null>(null);
  const [action, setAction] = useState<{
    eventName: string;
    data: IVehicleVisualRecord;
  }>();
  const [data, setData] = useState(props.data);
  const [reload, setReload] = useState(false);

  const [isEditingReason, setIsEditingReason] = useState(false);
  const [newReasonText, setNewReasonText] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setNewReasonText(props.data.returnReason || "");
  }, [props.data]);

  const reloadPage = () => {
    window.location.reload();
  };
  const formik = useFormik({
    initialValues: {
      devolutionPhotos: props.data.photos.devolutionPhotos,
      // outras propriedades inicializadas aqui
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      values;
    },
    // outras opções do Formik aqui
  });

  useEffect(() => {
    if (props.data !== undefined) {
      props.data && setvehicleId(vehicleId);
    }
  }, [props.data, vehicleId]);

  useEffect(() => {
    if (!action?.data) {
      return;
    }
    setData(action.data);
    formik.resetForm({
      values: {
        ...formik.values, // mantém os outros campos se quiser
        devolutionPhotos: action.data.photos.devolutionPhotos,
      },
    });
    setReload(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action]);

  const isAction = (eventName: string) => action?.eventName === eventName;

  const handleSaveNewReason = async () => {
    if (!data._id || !newReasonText.trim() || isSaving) return;

    setIsSaving(true);
    try {
      const finalReason = data.returnReason
        ? `${data.returnReason}\n${newReasonText}`
        : newReasonText;

      const result = await updateVehicleVisualRecordField(
        data._id,
        "returnReason",
        finalReason
      );

      if (result.ok) {
        setData((prevData) => ({ ...prevData, returnReason: finalReason }));

        setNewReasonText("");

        setIsEditingReason(false);
        setReload(true);
      } else {
        alert("Erro ao salvar a observação de devolução: " + result.message);
      }
    } catch (error) {
      console.error("Erro ao salvar a nova observação de devolução:", error);
      alert("Erro ao salvar a observação. Verifique o console.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-10 bg-black bg-opacity-30 flex justify-center items-center p-4">
      <FormikProvider value={formik}>
        <section
          style={{ backgroundColor: "rgb(179, 175, 175)" }}
          className=" flex flex-col items-center rounded-md shadow-lg max-w-[90%] md:max-w-2xl mx-auto p-4 max-h-[calc(100vh-4rem)] overflow-auto"
        >
          <h2 className="text-2xl font-semibold mb-4">Detalhes da devolução</h2>
          <div className="flex flex-wrap justify-center">
            {data.photos.devolutionPhotos?.map((doc, index) => (
              <div
                key={index}
                className={`flex flex-col space-y-2 p-3 my-0 rounded ${
                  index % 2 ? "bg-gray/5" : "bg-gray/5"
                }`}
              >
                <DetailsImageVehicleRow
                  name={`devolutionPhotos.${index}`}
                  initialData={doc || {}}
                  prefix="devolucao"
                  vehicleId={props.data.vehicleId}
                />
              </div>
            ))}
          </div>
          <div className="w-full sm:w-[70%] h-auto min-h-[200px] p-2 rounded-md shadow-lg mb-8 bg-white/50 text-black overflow-auto relative">
            {!isEditingReason && (
              <button
                onClick={() => {
                  setIsEditingReason(true);
                  setNewReasonText("");
                }}
                className="absolute top-2 right-2 p-1 bg-gray-300 rounded-full hover:bg-gray-400 z-1"
                title="Adicionar Observação"
              >
                <FaPencilAlt className="w-4 h-4 text-gray-700" />
              </button>
            )}

            <p className="font-bold">Observações: </p>

            {isEditingReason ? (
              <div className="flex flex-col space-y-2">
                <textarea
                  className="w-full p-2 border border-gray-400 rounded-md h-32 resize-none"
                  value={newReasonText}
                  onChange={(e) => setNewReasonText(e.target.value)}
                  placeholder={
                    data.returnReason
                      ? `Observações anteriores:\n${data.returnReason}\n\nDigite a nova observação aqui:`
                      : "Digite a primeira observação aqui:"
                  }
                />
                <div className="flex justify-end space-x-2">
                  <button
                    onClick={() => {
                      setNewReasonText(data.returnReason || "");
                      setIsEditingReason(false);
                    }}
                    className="bg-red-500 text-white px-4 py-2 rounded"
                    disabled={isSaving}
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleSaveNewReason}
                    className="bg-green-600 text-white px-4 py-2 rounded flex items-center"
                    disabled={isSaving || !newReasonText.trim()}
                  >
                    {isSaving ? (
                      <>
                        <svg
                          className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Salvando...
                      </>
                    ) : (
                      <>
                        <FaCheck className="w-4 h-4 mr-2" />
                        Confirmar
                      </>
                    )}
                  </button>
                </div>
              </div>
            ) : (
              <p className="mb-4 whitespace-pre-wrap">{data.returnReason}</p>
            )}
          </div>

          <div className="flex justify-around w-full">
            <button
              onClick={() =>
                setAction({ eventName: "addFile", data: props.data })
              }
              className="bg-redPrimary text-white w-34 border-black border-opacity-30 shadow-md relative self-end"
            >
              Adicionar Fotos
            </button>

            <button
              onClick={() => {
                props.onClose && props.onClose();
                reload && reloadPage();
              }}
              className="bg-redPrimary text-white w-24 border-black border-opacity-30 shadow-md relative self-end"
            >
              Fechar
            </button>
          </div>
        </section>
        {isAction("addFile") && props.data._id && (
          <ModalAddPhotos
            vehicleId={data.vehicleId}
            docType={"devolucao"}
            onClose={props.onClose as () => void}
            visualRecordId={props.data._id as string}
            closeAndUpdate={(data) => setAction(data)}
          ></ModalAddPhotos>
        )}
      </FormikProvider>
    </div>
  );
}
